import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";


const ReadyForFilingModal = ({readyForFilingOpen, setReadyForFilingOpen, setConfirmFiling}) => (
    <Dialog
        open={readyForFilingOpen}
        // onClose={() => handleClose(false)}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
    >
        <DialogContent>
            <DialogContentText id="confirmation-dialog-description">Only selected forms will move to "Ready For Filing" status. Please select the option below</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => {
                setConfirmFiling(false), setReadyForFilingOpen(false);
            }} variant="outlined" color="primary">
                Exit The Process
            </Button>
            <Button onClick={() => {
                setConfirmFiling(true), setReadyForFilingOpen(false);
            }} color="primary" autoFocus style={{backgroundColor: "#010160", color: "white"}}>
                Continue Editing
            </Button>
        </DialogActions>
    </Dialog>
);


export default ReadyForFilingModal;